// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"b33aecdb","655":"ae047101"}[chunkId] + ".chunk.js";
};